// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

let fadeOptions = {
	"duration": 200,
	"delay": 0
};

const playVideo = () => {
	 $w('#widgetVideoCta').hide()
        .then(() => $w('#widgetVideoCover').hide('fade', fadeOptions))
        .then(() => $w('#widgetVideo').show('fade', fadeOptions))
        .then(() => $w('#widgetVideo').play())
}

export function widgetVideoCta_click(event) {
	//Add your code for this event here: 
	playVideo();
}